export type SortOrder = 'asc' | 'desc';

interface SortOptions {
  orderBy: string;
  orderSortType: SortOrder;
}

function sortDetailsOnFrontEnd<T>(details: T[], { orderBy, orderSortType }: SortOptions): T[] {
  if (!details || details.length === 0) return [];

  const isAsc = orderSortType === 'asc';
  const compare = (a: any, b: any, field: string): number => {
    const valA = a[field];
    const valB = b[field];

    // Null handling
    if (valA === null && valB === null) return 0;
    if (valA === null) return isAsc ? -1 : 1;
    if (valB === null) return isAsc ? 1 : -1;

    if (valA < valB) return isAsc ? -1 : 1;
    if (valA > valB) return isAsc ? 1 : -1;

    // Tie-breaker: compare by caseNumber
    const caseA = a.caseNumber;
    const caseB = b.caseNumber;

    if (caseA < caseB) return 1;
    if (caseA > caseB) return -1;
    return 0;
  };

  const fieldMap: Record<string, string> = {
    parentEventId: 'parentEventId',
    erpOrderNumber: 'erpOrderNumber',
    accountNumber: 'accountNumber',
    createdDate: 'createdDate',
    returnExpiryDate: 'returnExpiryDate',
    type: 'diplayOrderType',
    salesRepName: 'salesRepName',
  };

  const field = fieldMap[orderBy];

  if (field) {
    return details.sort((a, b) => compare(a, b, field));
  }

  // Default sort fallback: caseNumber
  return details.sort((a, b) => compare(a, b, 'caseNumber'));
}

function filterBySearchableFields<T>(
  data: T[],
  searchText: string,
  searchableFields: (keyof T)[]
): T[] {
  if (!searchText) return data;

  const lowerSearch = searchText.toLowerCase();

  return data.filter(item =>
    searchableFields.some(field => {
      const value = item[field];
      return (
        value !== null &&
        value !== undefined &&
        String(value)
          .toLowerCase()
          .includes(lowerSearch)
      );
    })
  );
}

const inventoryHelper = {
  filterBySearchableFields,
  sortDetailsOnFrontEnd,
};

export default inventoryHelper;
